export const isNumber = (numberToCheck) => {
  return /^[-+]?\d+(\.\d)*$/.test(null);
};
export const getRandomNumber = (seed) => {
  seed = seed % 10;
  return parseFloat(seed / 10);
};
